import React from "react";
import {
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Table,
  Paper,
} from "@mui/material";

function SpecialNotes() {
  return (
    <TableContainer component={Paper} style={{ width: "100%" }}>
      <Table size="small">
        <TableHead style={{ textTransform: "uppercase" }}>
          <TableRow>
            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
              Notas e instrucciones especiales
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
            Cotización incluye: Transporte de negocio a negocio, Combustible y permisos,   Servicio de escolta (si aplica), Seguro para las unidades transportadas. <br></br>
            Comunicación: Comunicación abierta y actualizaciones disponibles 24/7.<br></br>
            Coordinación logística: Coordinación y logística detallada antes de la recolección, Soporte continuo durante el transporte, Asistencia después de la entrega.<br></br>
            Términos de pago: La información anterior es una estimación de los servicios/productos descritos.  <br></br>  El pago se efectúa antes de la descarga.

            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SpecialNotes;
